import { identity } from 'lodash';
import layeredSoilAttribute from './layeredSoilAttribute';

const organicMatter = (allLayers: boolean) =>
  layeredSoilAttribute({
    allLayers,
    key: 'Soil Health: Organic Matter',
    ratingCol: {
      displayString: 'Rating',
      accessor: 'mapUnitRatingString',
      format: (percent: Nullable<string>) =>
        percent == null ? 'N/A' : `${percent}%`,
      csvFormat: identity,
    },
    ruleId: '2647',
    units: '% organic matter',
  });

export const ORGANIC_MATTER_ALL_LAYERS = organicMatter(true);
export const ORGANIC_MATTER_SURFACE_LAYER = organicMatter(false);
